import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import RevolutionizeImg from "../../../images/location_new/fold7/ios-skyline.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";

function Revolutionize(props) {
  return (
    <div className="revolutionize_section">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Why Choose TekRevol as One of the iPhone Apps Development
              Companies in UK?
            </h2>
            <p>
              Opting for TekRevol in London for mobile app development is a
              strategic decision for various compelling reasons. Our expert team
              specializes in developing applications for iPhone, ensuring
              top-notch services from skilled iPhone application developers. We
              prioritize staying ahead of technology trends, ensuring your app
              benefits from cutting-edge solutions. TekRevol stands out for its
              commitment to tailored app development, recognizing each
              business's unique requirements. Our dedication to affordability
              ensures top-quality apps without exceeding your budget. Trust us
              for adept development of applications for iPhone, backed by our
              proficient iPhone application developers and specialized iPhone
              development services.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="revolutionize_img"
          >
            <LazyLoadImage
              src={RevolutionizeImg}
              effect="blur"
              alt="iPhone-app-developers-london"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Revolutionize;
